import { useMutation, useQuery } from "@tanstack/react-query";
import React from "react";
import { useParams } from "react-router-dom";
import { apiRequest } from "../../util/apiUtils";
import { toast } from "react-toastify";
import Badge from "../../components/elements/Badge";
import Lottie from "lottie-react";
import loading from "../../assets/lottie/Loading.json";
import notFound from "../../assets/lottie/not-found.json";
import Success from "../../assets/lottie/Success.json";

const Invitation = () => {
  const { orgId, code } = useParams();

  const {
    mutate: accept,
    isPending,
    data,
  } = useMutation({
    mutationFn: async (value) => {
      const res = await apiRequest("patch", "organization/accept-invitation", {
        body: value,
      });
      return res?.data;
    },
    onSuccess: (res) => {
      if (res?.status === 200) {
        toast.success(res?.message);
      } else {
        toast.info(res?.error || res?.message);
      }
      return res;
    },
    onSettled: (res) => {
      return res;
    },
  });

  const {
    data: verifyCode,
    isLoading,
    isFetching,
  } = useQuery({
    queryKey: ["verifyCode", orgId, code],
    enabled: !!(orgId && code),
    queryFn: async () => {
      const res = await apiRequest("patch", "organization/verify-token", {
        body: { code, organization: orgId },
      });
      if (res?.data?.status === 200) {
        accept({ code, organization: orgId });
      }
      return res?.data;
    },
  });

  return (
    <div className="w-screen h-screen flex items-center justify-center overflow-hidden">
      {isPending || isLoading || isFetching ? (
        <div className="flex flex-col items-center">
          <div className="w-28 h-28">
            <Lottie
              animationData={loading}
              loop={true}
              className="scale-[1.4]"
            />
          </div>
          <div className="font-medium text-lg text-deep-purple">
            Please wait verifing invitation
          </div>
        </div>
      ) : verifyCode?.status !== 200 ? (
        <Lottie animationData={notFound} loop={true} />
      ) : data?.status === 200 ? (
        <div className="flex flex-col items-center">
          <div className="w-28 h-28">
            <Lottie
              animationData={Success}
              loop={false}
              className="scale-[1.4]"
            />
          </div>
          <div className="font-medium text-lg text-deep-purple mt-5">
            verify invitation successfuly
          </div>
        </div>
      ) : (
        <div>Invitation rejected</div>
      )}
    </div>
  );
};

export default Invitation;
